import React, {useState} from 'react';

const Block = (props) => {
  let item = null;
  const [covered, setCovered] = useState(true);

  const clickBlock = () => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const edit = params.get('edit');
    if (covered) {
      let today = new Date();
      let allowedDate = new Date('December '+props.day+', 2019 00:00:01');
      if (today>=allowedDate || edit==="1") {
        setCovered(false);
        props.toggleModal(props);
      }
      else {
        props.toggleDateModal();
      }
    }
    else {
      props.toggleModal(props);
    }
  }

  /// It's not time yet :)

  if (props.id==="block-0") {
    item = <div className="intro-block block-card" key="intro" id={props.id}>
      <div className="intro-block-inner">
        <h1>DARIAH in 2019</h1>
      </div>
    </div>
  }
  else {
    let cardText = [];
    let cardImg = [];
    if (props.image!=="") {
      let src = "./images/thumbnails/"+props.image;
      cardImg = <img src={src} className="block-card-img" alt="" />
    }
    if (props.image==="" && props.youtube!=="") {
      let youtubeURL = props.youtube.replace("https://www.youtube.com/watch?v=", "");
      let src = "https://img.youtube.com/vi/"+youtubeURL+"/0.jpg";
      cardImg = <img src={src} className="block-card-img" alt="" />
    }
    if (props.message!=="") {
      let introText = props.message;
      if (props.message.length>150) {
        let index = props.message.substring(0,150).lastIndexOf(" ");
        introText = props.message.substring(0,index)+" ...";
      }
      cardText = <div className="block-card-body">
        <div className="intro-text" dangerouslySetInnerHTML={{__html: introText}}></div>
      </div>
    }
    let coverHidden = " hidden";
    if (covered) {
      coverHidden = "";
    }
    let cover = <div className={"block-card-cover"+coverHidden}><span>{props.day}</span></div>;
    let hidden = "";
    if (props.day==="blank") {
      hidden = " hidden";
    }
    item = <div style={props.style} className={"block-card"+hidden} key={props.day} onClick={()=>clickBlock()} id={props.id}>
      {cover}
      {cardImg}
      {cardText}
    </div>
  }

  return item;
}

export default Block;
